import React from 'react';
import { withRouter } from 'react-router-dom';

class Home extends React.Component {

    constructor() {

        super();
        this.mudarSenha = this.mudarSenha.bind(this);

        let usuarioInfo = JSON.parse(localStorage.usuarioInfo);

        this.state = {
            nome: usuarioInfo.nome,
            email: usuarioInfo.email,
            centro: usuarioInfo.centro,
        }

    }

    mudarSenha() {
        this.props.history.push("/mudarsenha");
    }

    render() {
        return (
            <div>
                <p class="home-txt"><b>Usuário:</b> { this.state.nome }</p>
                <p class="home-txt"><b>E-mail:</b> { this.state.email }</p>
                <p class="home-txt"><b>Centro:</b> { this.state.centro }</p>
                <button type="button" id="home-mudar-senha-btn" onClick={ this.mudarSenha }>
                    Mudar Senha
                </button>
            </div>
        );
    }

}

export default withRouter(Home);

